<template>
  <div class="fts-expression formula-expression">
    <vue-tribute :options="tributeOptions">
      <div
        ref="formulaExpression"
        @click="test"
        @input="updateContent"
        v-html="content"
        class="formula"
        placeholder="type formula here. # for hints"
        contenteditable="true"
        @keydown.enter.prevent
        @paste.prevent="paste($event)"
      ></div>
    </vue-tribute>
    <div class="editor-expression">
      {{innerExpression}}
    </div>
  </div>
</template>
<script>
import VueTribute from "vue-tribute";
import "tributejs/dist/tribute.css";
import FTSFormulaInformationUnit from "../design/formula/FTSFormulaInformationUnit";
import commons from "../commons/commons";
import tributeCaretMixin from "../commons/tributeCaretMixin";

export default {
  mixins: [tributeCaretMixin],
  props: {
    formula: String,
    information: Array,
  },
  model: {
    prop: 'formula'
  },
  data: () => ({
    content: "",
    innerExpression: "",
    previousContext: null,
    tributeOptions: {
      trigger: "#",
      allowSpaces: true,
      values: [],
      lookup: "displayName",
      requireLeadingSpace: false,
      replaceTextSuffix: "",
      itemClass: "information-unit-select",
      menuItemTemplate: function (item) {
        return `<span><i class="information-icon ${commons.informationIcon(
          item.original.type
        )}"></i> <span>${item.string}</span></span>`; //item.string
      },
    },
  }),
  methods: {
    test($event) {
      console.log($event);
    },
    paste(evt) {
      var text = evt.clipboardData.getData("text/plain");
      document.execCommand("insertHTML", false, text);
    },
    updateContent($event) {
      let re = /<fts-i-unit contenteditable="false">(?<display>.*?)<\/fts-i-unit>/g;
      let formulaText = $event.target.innerHTML.replace(re, "field('$1')");
      formulaText = formulaText.replaceAll("&nbsp;", " ");
      formulaText = formulaText.replaceAll("<br>", "");
      formulaText = formulaText.replaceAll("&gt;", ">");
      formulaText = formulaText.replaceAll("&lt;", "<");
      formulaText = formulaText.replaceAll("&amp;", "&");
      this.innerExpression = formulaText;
      this.$emit("input", formulaText);
    },
    async autofill(text, cb) {
      var rangeStart = window.getSelection().getRangeAt(0).startContainer;
      if (
        rangeStart &&
        rangeStart.data &&
        rangeStart.data.indexOf('#') == 0 &&
        rangeStart.previousSibling != null &&
        rangeStart.previousSibling.previousSibling != null
      ) {
        let re = /<fts-i-unit contenteditable="false">(?<display>.*?)<\/fts-i-unit>/g;
        let results = rangeStart.previousSibling.previousSibling.outerHTML.matchAll(
          re
        );
        let displayName = "";
        for (let result of results) {
          displayName = result.groups.display;
        }
        this.previousContext = this.information.find(
          (x) => x.displayName == displayName
        );
        console.log("continue:" + this.previousContext);
        if (this.previousContext != null && this.previousContext.fields) {
          this.previousContext.fields.forEach(x => x.parent = this.previousContext);
          cb(this.previousContext.fields);
        } else if(this.previousContext.connection) {
          console.log(this.previousContext.connection);
          let result = await this.$store.dispatch('loadInformation', { name: this.previousContext.connection });
          result.data.forEach(x => x.parent = this.previousContext);
          cb(result.data);
        }
      } else {
        this.previousContext = null;
        cb(this.selection);
      }
    },
    selectTemplate(item) {
      if(item.original.parent != null)
        return `.<fts-i-unit contenteditable="false">${item.original.displayName.replace('\'', '\\\'')}</fts-i-unit>`;

      return `<fts-i-unit contenteditable="false">${item.original.displayName.replace('\'', '\\\'')}</fts-i-unit>`;
    },
    replaced(info) {},
    updateDisplay(formula) {
      let re = /field\('(?<display>.*?)'\)/g;
      try {
        this.content = formula.replace(
          re,
          '<fts-i-unit contenteditable="false">$1</fts-i-unit>'
        ).replace('<br>', '');
      } catch(err) { 
        console.warn(`FTSExpression error: ${err}`) 
      }

      this.innerExpression = formula;
    },
  },
  components: {
    VueTribute,
    "fts-formula-information-unit": FTSFormulaInformationUnit,
  },
  watch: {
    formula(newVal) {
      if (!newVal) {
        this.content = ""  
        this.innerExpression = ""
        this.$refs.formulaExpression.innerHTML = ""
      }
    }
  },
  computed: {
    selection() {
      return this.information.concat([
        { 'displayName': '#DocumentID' },
        { 'displayName': '#Date' },
        { 'displayName': '#Created By' },
        { 'displayName': '#Created Date' },
        { 'displayName': '#Updated By' },
        { 'displayName': '#Updated Date' },
        { 'displayName': '#State' },
      ])
    }
  },
  mounted() {
    let vm = this;
    this.tributeOptions.selectTemplate = this.selectTemplate;
    this.tributeOptions.values = function (text, cb) {
      vm.autofill(text, (users) => cb(users));
    };
    this.bindTributeCaretGuard();
    this.updateDisplay(this.formula);
  },
};
</script>

<style lang="scss">
.fts-expression {
  .formula {
    &:empty:before {
      content: attr(placeholder);
      -webkit-text-fill-color: var(--fts-default);
    }
    fts-i-unit {
      background-color: rgb(200, 240, 255);
      padding: 3px;
      margin: 1px;
      cursor: pointer;
    }
  }
  .information-unit-select {
    margin: 3px;
  }
  .editor-expression {
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: .675rem;
    color: var(--fts-default);
  }
}
</style>